import React, { lazy } from 'react';

const TripList = lazy(() => import('./TripList'));
const TripDetails = lazy(() => import('./TripDetails'));

export default [
  { path: 'trips', element: <TripList /> },
  { path: 'trips/:id', element: <TripDetails /> }
];
